import { tv } from 'tailwind-variants'

import { body2 } from '@ui-kit/core/typography'

export const selectOption = tv({
  slots: {
    container: 'flex flex-row rounded-lg bg-grey-100 px-[20px] py-[10px]',
    text: body2({ bold: true }),
    leading: 'size-[22px] items-center justify-center overflow-hidden rounded-full bg-white',
    leadingImage: 'size-full',
  },
  variants: {
    isChecked: {
      true: {
        container: 'bg-black',
        text: 'text-white',
      },
    },
    inverted: {
      true: {},
    },
    hasLeading: {
      true: {
        container: 'items-center gap-1.5 pl-1.5',
      },
    },
  },
  defaultVariants: {
    isChecked: false,
  },
  compoundVariants: [
    {
      isChecked: true,
      inverted: true,
      className: {
        container: 'bg-black',
        text: 'text-white',
      },
    },
  ],
})

export const multiSelect = tv({
  slots: {
    container: 'flex flex-row flex-wrap gap-2.5',
  },
})
